// extracted by mini-css-extract-plugin
export default {"modalWrapper":"license_modalWrapper__TRv6h","modalWrapper__footer":"license_modalWrapper__footer__DSLtC","licenseWrapper":"license_licenseWrapper__Nf0XD"};